// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "home" + "." + "6e7eb06b7860e398e993" + ".css";
};